import { Group, NumberInput, Select } from '@mantine/core';
import { useCreateRuleFormContext } from 'context/FormContext';
import { RuleConditions } from 'models/rules';
import { useTranslation } from 'react-i18next';
import { displayFormError } from 'utils/validation';
import { AccordionWithSwitch } from './AccordionWithSwitch';

export const HeartRateFields = () => {
  const { t } = useTranslation();
  const { getInputProps, values, errors } = useCreateRuleFormContext();

  const dataField = 'data.heartRhythmMeasurement.heartRateCondition';

  return (
    <AccordionWithSwitch title={t('heart_rate_label')} dataField={dataField}>
      <Group gap={'md'} align={'flex-start'}>
        <Select
          label={t('condition_label')}
          {...getInputProps(`${dataField}.heartRate.condition`)}
          data={Object.values(RuleConditions).map((value) => ({
            value,
            label: t(`${value}_label`),
          }))}
          w={130}
          disabled={values.formDisabled}
        />
        <NumberInput
          label={t('threshold_label')}
          {...getInputProps(`${dataField}.heartRate.value`)}
          allowNegative={false}
          allowDecimal={false}
          min={1}
          max={200}
          suffix={` ${t('bpm_label')}`}
          styles={{ input: { width: 110 } }}
          disabled={values.formDisabled}
          clampBehavior={'strict'}
          error={displayFormError({ errors, dataField: `${dataField}.heartRate.value` })}
        />
      </Group>
    </AccordionWithSwitch>
  );
};
